import React from "react";
import styles from "./FHIRPatient.module.scss";
import RecordOverrideOptions from "../../routes/NewSearchRecords/SearchRecordTable/RecordOverrideOptions";

const Coverage = ({
  data,
  summary: isSummary,
  oncRecordOverrideIconClick,
  className,
  isInvisible = false,
  isAggregateInfo = false
}) => {
  if (isSummary) {
    return null;
  }

  const prepareOverrideOriginalValue = identifier => {
    const extensionArray = identifier.hasOwnProperty("extension")
      ? identifier.extension.filter(
          item =>
            item.url ===
            "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override"
        )
      : [];
    let extensionMap = {
      Field: "Coverage",
      overrideIconClicked: true
    };

    if (extensionArray.length > 0) {
      const elementCoverage = extensionArray[0].valueIdentifier;
      const overrideType = !identifier.hasOwnProperty("use")
        ? "Invalid"
        : identifier.use === "old"
        ? "Inactive"
        : "";
      extensionMap = {
        ...extensionMap,
        "Plan Name": elementCoverage.system
          ? elementCoverage.system.split("|")[0]
          : "-",
        "Insurance ID": elementCoverage.value
          ? elementCoverage.value.split("|")[1]
          : "-",
        Payer: (
          <div>
            {elementCoverage.system
              ? elementCoverage.system.split("|")[1]
              : "-"}{" "}
            <i>
              (
              {elementCoverage.value
                ? elementCoverage.value.split("|")[0]
                : "-"}
              )
            </i>
          </div>
        ),
        "Mark as": overrideType
      };
    }
    oncRecordOverrideIconClick(extensionMap);
  };

  return (
    <section>
      <div className={styles.identifierDiv + " " + styles.header}>
        {!isAggregateInfo && <div className={styles.actionColumn} />}
        <div>
          <h4>Plan Name</h4>
        </div>
        <div>
          <h4>Insurance ID</h4>
        </div>
        <div>
          <h4>Payer</h4>
        </div>
        <div>
          <h4>Source</h4>
        </div>
      </div>

      {data.map((id, index) => {
        const coverageMap = {
          Field: "Coverage",
          "Plan Name": id.system ? id.system.split("|")[0] : "-",
          "Insurance ID": id.value ? id.value.split("|")[1] : "-",
          Payer: (
            <div>
              {id.system ? id.system.split("|")[1] : "-"}{" "}
              <i>({id.value ? id.value.split("|")[0] : "-"})</i>
            </div>
          ),
          Source:
            id.extension &&
            id.extension.filter(e => e.url.includes("#sourceCode")).length > 0
              ? id.extension.filter(e => e.url.includes("#sourceCode"))[0]
                  .valueString
              : "-",
          "Mark as": "",
          originalFieldName: "identifier",
          originalFieldData: id
        };
        return (
          <div className={styles.identifierDiv}>
            {!isAggregateInfo && (
              <div className={styles.actionColumn}>
                {oncRecordOverrideIconClick && !isInvisible && (
                  <RecordOverrideOptions
                    detailsMap={coverageMap}
                    onClickRecordOverrideAction={detailsMap =>
                      oncRecordOverrideIconClick(detailsMap)
                    }
                    onClickRecordOverrideButton={() =>
                      prepareOverrideOriginalValue(
                        coverageMap.originalFieldData
                      )
                    }
                    extension={
                      id.hasOwnProperty("extension")
                        ? id.extension.filter(
                            item =>
                              item.url ===
                              "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override"
                          )
                        : []
                    }
                  />
                )}
              </div>
            )}
            <div>
              <div>{coverageMap["Plan Name"]}</div>
            </div>
            <div>
              <div>{coverageMap["Insurance ID"]}</div>
            </div>
            <div>
              <div>{coverageMap["Payer"]}</div>
            </div>
            <div>
              <div>{coverageMap["Source"]}</div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Coverage;
